import { Object3D } from "three";
import { BatchedRenderer, QuarksUtil } from "three.quarks";
import { clone } from "three/examples/jsm/utils/SkeletonUtils.js";
import { GameResourcesPackage } from "../../../../../resources/GameResourcesPackage";

export class WheelEarthClodsParticle extends Object3D {
    private particles: Object3D;
    public constructor(
        private readonly gameResources: GameResourcesPackage,
        private readonly particlesRenderer: BatchedRenderer
    ) {
        super();
        this.particles = clone(this.gameResources.assets_game_particles_tractor_earht_clods_thjson);
        QuarksUtil.setAutoDestroy(this.particles, true);
        QuarksUtil.addToBatchRenderer(this.particles, this.particlesRenderer);
        this.add(this.particles);
    }

    public play(): void {
        QuarksUtil.play(this.particles);
    }

    public stop(): void {
        QuarksUtil.stop(this.particles);
    }
}
